import React, {useEffect, useState} from "react";
import ConfirmButton from "./ConfirmButton";
import {CommentField} from "../form/simpleFields/CommentField";
import ConfirmIconButton from "./ConfirmIconButton";


const ConfirmWithCommentButton = ({
                                      confirmTitle,
                                      confirmDescription,
                                      onConfirm,
                                      variant,
                                      tooltip,
                                      children,
                                      className,
                                      disabled,
                                      icon,
                                      comment,
                                      modalSize,
                                      buttonsConf,
                                      commentRequired = true,
                                      setComment
                                  }) => {

    const [isValid, setIsValid] = useState(false);

    function validateData() {
        if (commentRequired && (!comment || comment === "")) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    }

    useEffect(validateData, [comment]);


    return (
        <>
            {icon &&
                <ConfirmIconButton
                    variant={variant}
                    className={className}
                    disabled={disabled}
                    icon={icon}
                    ready={isValid}
                    tooltip={tooltip}

                    confirmTitle={confirmTitle}
                    confirmDescription={confirmDescription}
                    onConfirm={onConfirm}
                    buttonsConf={buttonsConf}
                    additionalFields={<CommentField valid={isValid} onChange={e => setComment(e.target.value)}
                                                    value={comment}/>}
                    form={true}
                    modalSize={modalSize}
                >{children}</ConfirmIconButton>
            }
            {!icon &&
                <ConfirmButton
                    variant={variant}
                    className={className}
                    disabled={disabled}
                    canConfirm={isValid}
                    confirmTitle={confirmTitle}
                    confirmDescription={confirmDescription}
                    onConfirm={onConfirm}
                    buttonsConf={buttonsConf}
                    additionalFields={<CommentField valid={isValid} onChange={e => setComment(e.target.value)}
                                                    value={comment}/>}
                    form={true}
                    modalSize={"md"}
                >{children}</ConfirmButton>
            }
        </>
    );
};

export default ConfirmWithCommentButton;